import { useEffect } from 'react'

/**
 * Hook to handle Safari Mobile's dynamic viewport height changes.
 *
 * Safari's bottom browser bar appears/disappears on scroll, causing
 * window.innerHeight to change dynamically. This hook updates a CSS
 * custom property to track the actual visible viewport height.
 *
 * Based on: https://medium.com/javascript-in-plain-english/how-to-fix-the-safari-mobile-bottom-browser-bar-issue-6b9239494ee8
 */
export function useSafariViewportFix() {
  useEffect(() => {
    const setViewportHeight = () => {
      // Get the actual visible viewport height
      const vh = window.innerHeight * 0.01
      // Set CSS custom property
      document.documentElement.style.setProperty('--vh', `${vh}px`)
    }

    // Set on mount
    setViewportHeight()

    // Update on resize (includes Safari bar appearing/disappearing)
    window.addEventListener('resize', setViewportHeight)

    // Update on orientation change
    window.addEventListener('orientationchange', setViewportHeight)

    // Cleanup
    return () => {
      window.removeEventListener('resize', setViewportHeight)
      window.removeEventListener('orientationchange', setViewportHeight)
    }
  }, [])
}
